import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45path_45parser_45global from "/var/www/html/middleware/00.path-parser.global.ts";
import _01_45user_45global from "/var/www/html/middleware/01.user.global.ts";
import _02_45amplitude_45global from "/var/www/html/middleware/02.amplitude.global.ts";
import _03_45menu_45global from "/var/www/html/middleware/03.menu.global.ts";
export const globalMiddleware = [
  validate,
  _00_45path_45parser_45global,
  _01_45user_45global,
  _02_45amplitude_45global,
  _03_45menu_45global
]
export const namedMiddleware = {
  admin: () => import("/var/www/html/middleware/admin.ts"),
  auth: () => import("/var/www/html/middleware/auth.ts"),
  guest: () => import("/var/www/html/middleware/guest.ts")
}